// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1)
// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T3 Склад)
// Режим вида ячеек «Composition» (Склад, §1.4 / §1.6 плана p149). Данных бэка не нужно (needsData: false): дети строки дерева REPORT2 приходят вместе с ней
// в _doc.data (поле детей — childItemsPath грида; ctx.childrenOf(dataItem) → массив dataItem непосредственных детей).
// Слои круга ячейки-даты свёрнутого родителя = непосредственные дети: значение ребёнка — child[ctx.date][ctx.measure] (строки «20 000» нормализуются),
// заголовок — название строки ребёнка; цвет — по классу ячейки / строки ребёнка (сигнал cellRing_classRole: непокрыто → красный, излишек → тёмно-синий,
// выше максимума → синий; иначе фон cell-background-* через ctx.classColor = alert_classColor грида), иначе категориальная палитра COMPOSITION_COLORS
// по хешу названия (стабильна между ответами; совпадение у братьев — следующий свободный цвет).
// Σ детей < значения ячейки — остаток слоем «Other» серым; Σ детей > значения — слои нормализуются к значению ячейки (в подсказке — исходные значения).
// Раскрытый родитель (ctx.row.isCollapsed === false) — слоёв нет, кольцо снимается (грид переприменяет круг в formatItem при сворачивании; свёрнутость —
// в cacheKey). Строка без детей — один слой своим цветом (обычный круг значения ячейки).
// Возврат layersOf: { layers: [{ key, title, value, raw, color, tone }], value, caption, collapsed, over } | null
// IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by):
// режим переименован в «By child rows» (Підлеглі рядки; «Склад» читался как «склады»). Подпись слоя — значимые значения фиксированных колонок ребёнка
// (ctx.heads — [{ binding, title }] колонок слева от периодных, без служебных; ctx.textOf(di, binding) — текст ячейки, как его показывает грид):
// непустые и не равные значению той же колонки у родителя, через « · » в порядке колонок; нет таких — название строки, затем #i; одинаковые подписи — с #i.
// IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p185: у підписах шарів — лише значення, що різняться між підлеглими рядками): при двух и более детях в подпись идут только колонки,
// значения которых различаются между детьми (общие для всех — «Швейцария», «↑ Прихід» — ничего не различают); пусто после отбора — прежний порядок.
// Ключ слоя — подпись (цвет по её хешу). ctx.splitBy — binding колонки (параметр split_by строки опции): дети группируются по её тексту (значения
// суммируются; пусто — «(empty)»).
import { t as tI18n } from '@/i18n'
import { CELL_RING_COLORS, cellRing_classRole } from '@/utils/cellRing'

export const COMPOSITION_VIEW = 'composition'
// категориальная палитра детей (без красного и синих — они заняты сигналами колец)
export const COMPOSITION_COLORS = ['#5c6bc0', '#26a69a', '#ffa726', '#ab47bc', '#8d6e63', '#66bb6a', '#29b6f6', '#d4e157']
export const COMPOSITION_OTHER_COLOR = '#bdbdbd'
export const COMPOSITION_OTHER_KEY = '__other'

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const isObj = (o) => !!o && typeof o === 'object' && !Array.isArray(o)

// число ячейки: число как есть; строка — без пробелов / неразрывных пробелов / апострофов, «,» — десятичная (или разделитель тысяч при наличии «.»)
export function composition_num(v) {
    if (typeof v === 'number') return Number.isFinite(v) ? v : NaN
    if (v === null || v === undefined || typeof v === 'boolean') return NaN
    if (isObj(v) && 'value' in v) return composition_num(v.value)
    let s = String(v).replace(/[\s\u00a0\u202f']/g, '')
    if (!s) return NaN
    s = s.includes('.') ? s.replace(/,/g, '') : s.replace(',', '.')
    const n = Number(s)
    return Number.isFinite(n) ? n : NaN
}

// название строки: _isv_title / title (значение может быть объектом { value }) / _DLRow.title / name / id
export function composition_titleOf(di) {
    if (!isObj(di)) return ''
    for (const v of [di._isv_title, di.title, di._DLRow && di._DLRow.title, di.name, di.id]) {
        const s = isObj(v) ? str(v.value ?? v.title) : str(v)
        if (s) return s
    }
    return ''
}

// IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
// текст ячейки строки по binding: ctx.textOf (текст грида — dataMap / справочник / `<binding>-title`), иначе значение поля (объект — title / valueStr / value)
export function composition_text(di, binding, ctx = {}) {
    if (!isObj(di) || !str(binding)) return ''
    if (typeof ctx.textOf === 'function') {
        let s = ''
        try { s = str(ctx.textOf(di, binding)) } catch (e) { s = '' }
        return s
    }
    const v = di[binding]
    return isObj(v) ? str(v.title ?? v.valueStr ?? v.value) : str(v)
}
// IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
// подпись ребёнка из фиксированных колонок: непустые значения, отличные от значения той же колонки у родителя, через « · »; нет — ''
// distinct (IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p185: у підписах шарів — лише значення, що різняться між підлеглими рядками)): Set binding-ов, значения которых различаются между детьми, — берутся только они; без него — все колонки
export function composition_headTitle(kid, parent, ctx = {}, distinct = null) {
    const heads = Array.isArray(ctx.heads) ? ctx.heads : []
    const out = []
    for (const h of heads) {
        const b = isObj(h) ? h.binding : h
        if (distinct && !distinct.has(b)) continue   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p185: у підписах шарів — лише значення, що різняться між підлеглими рядками)
        const s = composition_text(kid, b, ctx)
        if (!s || s === composition_text(parent, b, ctx) || out.includes(s)) continue
        out.push(s)
    }
    return out.join(' · ')
}

// IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p185: у підписах шарів — лише значення, що різняться між підлеглими рядками)
// колонки, различающие детей: при двух и более детях — binding-и, у которых среди ВСЕХ детей (и нулевых) не меньше двух разных текстов
// (пустое — тоже значение); один ребёнок — null (подпись из всех непустых значений, как прежде)
export function composition_distinctHeads(kids, ctx = {}) {
    const list = Array.isArray(kids) ? kids : []
    if (list.length < 2) return null
    const heads = Array.isArray(ctx.heads) ? ctx.heads : []
    const out = new Set()
    for (const h of heads) {
        const b = isObj(h) ? h.binding : h
        if (!str(b)) continue
        const vals = new Set(list.map(k => composition_text(k, b, ctx)))
        if (vals.size > 1) out.add(b)
    }
    return out
}

// стабильный хеш названия (FNV-1a) → индекс палитры
export function composition_hash(s) {
    let h = 0x811c9dc5
    const x = str(s)
    for (let i = 0; i < x.length; i++) { h ^= x.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0 }
    return h >>> 0
}

// классы ячейки ребёнка: _DLRow.cells[binding].cssClasses + _DLRow.cssClasses (массивы или строки через пробел)
function classesOf(di, binding) {
    const dlr = isObj(di) ? di._DLRow : null
    const out = []
    for (const list of [dlr && dlr.cells && dlr.cells[binding] && dlr.cells[binding].cssClasses, dlr && dlr.cssClasses]) {
        const arr = Array.isArray(list) ? list : (typeof list === 'string' ? list.split(/\s+/) : [])
        for (const c of arr) { const s = str(c); if (s) out.push(s) }
    }
    return out
}

// цвет по классам: сигнал кольца (uncovered > excess > over-max) → цвет сигнала; фон cell-background-* → classColor(cls) (строка css или { r, g, b }); иначе ''
export function composition_classColor(classes, classColor) {
    const list = Array.isArray(classes) ? classes : []
    for (const kind of ['uncovered', 'excess', 'over-max']) {
        if (list.some(c => cellRing_classRole(c) === kind)) return CELL_RING_COLORS[kind]
    }
    if (typeof classColor !== 'function') return ''
    for (let i = list.length - 1; i >= 0; i--) {
        const c = list[i]
        if (!c.startsWith('cell-background-')) continue
        let col = null
        try { col = classColor(c) } catch (e) { col = null }
        if (typeof col === 'string' && str(col)) return str(col)
        if (isObj(col) && Number.isFinite(Number(col.r))) return `rgb(${Math.round(col.r)}, ${Math.round(col.g)}, ${Math.round(col.b)})`
    }
    return ''
}

// свёрнутость: строка грида wijmo с булевым isCollapsed — по ней; строки нет — свёрнута (круг показывается)
export function composition_collapsed(ctx) {
    const row = ctx && ctx.row
    return !(row && typeof row.isCollapsed === 'boolean' && row.isCollapsed === false)
}

function childrenOf(dataItem, ctx) {
    let kids = []
    try { kids = typeof ctx.childrenOf === 'function' ? ctx.childrenOf(dataItem) : [] } catch (e) { kids = [] }
    return Array.isArray(kids) ? kids.filter(isObj) : []
}
function valueAt(di, ctx) {
    const cell = isObj(di) ? di[ctx.date] : null
    return isObj(cell) ? composition_num(cell[ctx.measure]) : NaN
}

// слои: dataItem — строка, ctx — { t, binding, date, measure, value, row, childrenOf, classColor, heads?, textOf?, splitBy?, splitTitle? }   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
export function composition_layers(dataItem, binding, ctx = {}) {
    if (!isObj(dataItem)) return null
    const t = typeof ctx.t === 'function' ? ctx.t : tI18n
    const own = composition_num(ctx.value)
    const caption = composition_titleOf(dataItem)
    const kids = childrenOf(dataItem, ctx)
    const collapsed = composition_collapsed(ctx)
    if (!kids.length) {   // лист — обычный круг своим цветом
        if (!(own > 0)) return null
        const color = composition_classColor(classesOf(dataItem, binding), ctx.classColor) || COMPOSITION_COLORS[composition_hash(caption) % COMPOSITION_COLORS.length]
        return { layers: [{ key: caption || 'value', title: caption, value: own, raw: own, color, tone: 'solid' }], value: own, caption, collapsed, over: false }
    }
    if (!collapsed) return { layers: [], value: Number.isFinite(own) ? own : undefined, caption, collapsed: false, over: false }
    const used = new Set()
    const layers = []
    const splitBy = str(ctx.splitBy)   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
    const items = []   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): [{ title, value, classes }] — дети или группы по колонке split_by
    if (splitBy) {
        const byTitle = new Map()
        for (const k of kids) {
            const v = valueAt(k, ctx)
            if (!(v > 0)) continue
            const title = composition_text(k, splitBy, ctx) || t('(empty)')
            const g = byTitle.get(title)
            if (g) g.value += v
            else { const it = { title, value: v, classes: [] }; byTitle.set(title, it); items.push(it) }
        }
    } else {
        const distinct = composition_distinctHeads(kids, ctx)   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p185: у підписах шарів — лише значення, що різняться між підлеглими рядками)
        kids.forEach((k, i) => {
            const v = valueAt(k, ctx)
            if (!(v > 0)) return
            const title = (distinct && composition_headTitle(k, dataItem, ctx, distinct)) || composition_headTitle(k, dataItem, ctx) || composition_titleOf(k) || `#${i + 1}`   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p185: у підписах шарів — лише значення, що різняться між підлеглими рядками): пусто после отбора — прежний порядок
            items.push({ title, value: v, classes: classesOf(k, binding), n: i + 1 })
        })
        const cnt = new Map()   // одинаковые подписи (в т. ч. у всех детей одна) — с номером ребёнка: ключ слоя = подпись, должен быть уникален
        for (const it of items) cnt.set(it.title, (cnt.get(it.title) || 0) + 1)
        for (const it of items) if (cnt.get(it.title) > 1 && !/^#\d+$/.test(it.title)) it.title = `${it.title} #${it.n}`
    }
    items.forEach((it) => {   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
        const v = it.value, title = it.title
        let color = composition_classColor(it.classes, ctx.classColor)
        if (!color) {
            const n = COMPOSITION_COLORS.length
            const h = composition_hash(title) % n
            let j = 0
            while (j < n && used.has(COMPOSITION_COLORS[(h + j) % n])) j++
            color = COMPOSITION_COLORS[(h + (j < n ? j : 0)) % n]
        }
        used.add(color)
        layers.push({ key: title, title, value: v, raw: v, color, tone: 'solid' })   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): ключ — подпись
    })
    const sum = layers.reduce((s, l) => s + l.value, 0)
    if (!(sum > 0)) return null
    const splitTitle = splitBy ? (str(ctx.splitTitle) || splitBy) : ''   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
    if (!Number.isFinite(own)) return { layers, value: sum, caption, splitTitle, collapsed: true, over: false }   // у родителя нет числа — итог = Σ детей
    if (!(own > 0)) return null
    const eps = Math.abs(own) * 1e-9
    let over = false
    if (sum > own + eps) {   // Σ детей больше значения ячейки — нормализуем к нему
        const k = own / sum
        for (const l of layers) l.value = l.value * k
        over = true
    } else if (own - sum > eps) {
        layers.push({ key: COMPOSITION_OTHER_KEY, title: t('Other'), value: own - sum, raw: own - sum, color: COMPOSITION_OTHER_COLOR, tone: 'solid' })
    }
    return { layers, value: own, caption, splitTitle, collapsed: true, over }
}

// Alt-подсказка (IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): заголовок «By child rows[ · <колонка split_by>]: <родитель>»): строки «ребёнок — исходное значение — доля от значения ячейки»
export function composition_tip(res, ctx = {}) {
    if (!res || !Array.isArray(res.layers)) return null
    const t = typeof ctx.t === 'function' ? ctx.t : tI18n
    const total = res.layers.reduce((s, l) => s + Math.max(0, Number(l.value) || 0), 0)
    return {
        caption: [t('By child rows'), str(res.splitTitle)].filter(Boolean).join(' · ') + (str(res.caption) ? `: ${str(res.caption)}` : ''),   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): «Підлеглі рядки: <родитель>»
        rows: res.layers.filter(l => Number(l.value) > 0).map(l => ({ key: l.key, title: l.title, value: l.raw ?? l.value, color: l.color, share: total > 0 ? l.value / total : 0 })),
    }
}

// IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
// колонка split_by кнопки вида: поле кнопки (если бэк его пришлёт), иначе строка опции записи (doc.params.option_groups) — по id / title группы кнопки
// (params.group = id строки или её title) → binding | ''
export function composition_splitByOf(btn, rows) {
    if (!isObj(btn)) return ''
    const own = str(btn.split_by) || str(isObj(btn.params) ? btn.params.split_by : '')
    if (own) return own
    const g = str(isObj(btn.params) ? btn.params.group : '')
    if (!g || !Array.isArray(rows)) return ''
    const row = rows.find(r => isObj(r) && str(r.id) === g) || rows.find(r => isObj(r) && str(r.title) === g)
    return row ? str(row.split_by) : ''
}

export default {
    key: COMPOSITION_VIEW,
    title: 'By child rows',   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): было Composition («Склад» читался как «склады»)
    satellites: [],
    needsData: false,
    layersOf(dataItem, binding, ctx = {}) { return composition_layers(dataItem, binding, ctx) },
    tipOf(res, ctx = {}) { return composition_tip(res, ctx) },
    // ключ кеша грида: свёрнутость + число детей + Σ их значений в ячейке (правка ребёнка меняет круг родителя)
    cacheKey(dataItem, ctx = {}) {
        const kids = childrenOf(dataItem, ctx)
        if (!kids.length) return 'leaf'
        let s = 0
        for (const k of kids) { const v = valueAt(k, ctx); if (v > 0) s += v }
        return `${composition_collapsed(ctx) ? 'c' : 'o'}|${kids.length}|${s}|${str(ctx.splitBy)}`   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): + колонка split_by
    },
}
